import '../App.css';

export default function ItemForm({
  values,
  onChange,
  onSubmit,
  busy,
  error,
  submitText,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="form-container">
      <div className="form-group">
        <label htmlFor="name">Item Name:</label>
        <input
          id="name"
          name="name"
          type="text"
          value={values.name || ''}
          onChange={(e) => onChange({ ...values, name: e.target.value })}
          required
          placeholder="Enter item name (e.g., Plastic Bottle)"
          disabled={busy}
        />
      </div>

      <div className="form-group">
        <label htmlFor="image">Image URL:</label>
        <input
          id="image"
          name="image"
          type="url"
          value={values.image || ''}
          onChange={(e) => onChange({ ...values, image: e.target.value })}
          required
          placeholder="https://example.com/item-image.jpg"
          disabled={busy}
        />
      </div>

      <div className="form-group">
        <label htmlFor="material">Material Type:</label>
        <select
          id="material"
          name="material"
          value={values.material || ''}
          onChange={(e) => onChange({ ...values, material: e.target.value })}
          required
          disabled={busy}
        >
          <option value="">Select material type</option>
          <option value="Plastic">Plastic</option>
          <option value="Paper">Paper</option>
          <option value="Glass">Glass</option>
          <option value="Metal">Metal</option>
          <option value="Electronic">Electronic</option>
          <option value="Organic">Organic</option>
          <option value="Other">Other</option>
        </select>
      </div>

      <div className="form-group">
        <label htmlFor="quantity">Quantity:</label>
        <input
          id="quantity"
          name="quantity"
          type="number"
          min="0"
          step="1"
          value={values.quantity || ''}
          onChange={(e) => onChange({ ...values, quantity: parseInt(e.target.value) || 0 })}
          required
          placeholder="Enter quantity"
          disabled={busy}
        />
      </div>

      {error && <div className="error-box">{error}</div>}

      <button type="submit" className="submit-btn" disabled={busy}>
        {busy ? "Processing..." : submitText || "Submit"}
      </button>
    </form>
  );
}